import { Link } from "react-router-dom";
import SiteBreadcrumbs from "@/components/feature/Breadcrumbs";
import ArticleCard from "@/components/feature/ArticleCard";
import { getArticlesByTopic, topics } from "@/utils/content";
import { useSeo } from "@/hooks/useSeo";

export default function Topics() {
  useSeo({
    title: "专题栏目 - 圈内八卦内幕深度整理 | 瓜田秘闻社",
    description:
      "瓜田秘闻社专题栏目，按顶流风波、剧组秘闻、综艺内幕、代言与资源、私下交集、行业观察六大方向整理内容，把零散的八卦串成完整的来龙去脉。",
    keywords: "黑料吃瓜专题,圈内八卦专题,娱乐内幕,剧组秘闻,综艺内幕",
    canonical: "/topics",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "专题栏目",
      description: "按主题聚合的娱乐八卦与内幕整理专题",
      inLanguage: "zh-CN",
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://sdbjdz.cn/" },
          { "@type": "ListItem", position: 2, name: "专题栏目", item: "https://sdbjdz.cn/topics" },
        ],
      },
    },
  });

  return (
    <div className="w-full">
      <div className="w-full border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
          <SiteBreadcrumbs items={[{ label: "首页", to: "/" }, { label: "专题栏目" }]} />
          <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            专题栏目
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            一件事往往牵出好几条线。我们用专题把相关的瓜归到一起，让你顺着脉络一次看明白。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-12">
          {topics.map((topic) => {
            const list = getArticlesByTopic(topic.id).slice(0, 3);
            return (
              <section key={topic.id} className="grid grid-cols-1 gap-6 lg:grid-cols-12">
                <div className="lg:col-span-4">
                  <div className="relative h-44 w-full overflow-hidden rounded-lg bg-background-100">
                    <img
                      src={topic.image}
                      alt={`${topic.name}专题配图`}
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h2 className="font-heading text-xl font-bold text-background-50">
                        {topic.name}
                      </h2>
                      <p className="mt-1 text-xs text-accent-200">{topic.slogan}</p>
                    </div>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                    {topic.description}
                  </p>
                  <div className="mt-4 flex items-center gap-4">
                    <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                      共 {topic.count} 篇
                    </span>
                    <Link
                      to={`/news?topic=${topic.id}`}
                      className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
                    >
                      查看该专题 <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>

                <div className="lg:col-span-8">
                  {list.length > 0 ? (
                    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                      {list.map((article) => (
                        <ArticleCard key={article.id} article={article} />
                      ))}
                    </div>
                  ) : (
                    <p className="rounded-lg border border-dashed border-background-300 bg-background-100/60 p-6 text-sm text-foreground-500">
                      该专题内容正在整理中，稍后见。
                    </p>
                  )}
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}